module.exports = __webpack_public_path__ + "img/MVR-Cancer-Center.077db5ec.jpg";